import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import {search} from 'react-icons-kit/icomoon/search';
import {bin} from 'react-icons-kit/icomoon/bin';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ModalInfo from './ModalInfo';
import Help from '../../generics/help';

var Config = require('../../../config');

class SampleList extends Component{
	constructor(props){
		super(props);

		this.filter = this.filter.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.getList = this.getList.bind(this);

		this.state = {
			filterText:"",
			unit_entries:[],
			start_date:"",
			end_date:"",
			start_folio:"",
			end_folio:"",
			columns:[],
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			this.setState({
				start_date:aux[0].split('/').reverse().join('-'),
				end_date:aux[0].split('/').reverse().join('-')
			});

			this.getList();
		});

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=UNIT_ENTRIES',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
        	if(response !== undefined){
          		this.setState({ columns: response });
        	}
      	});

		
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_entries?start_date='+this.state.start_date+
			'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio+
			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({unit_entries:response})
			}
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	newEntry(){
		this.props.history.push('/entry_units/new');
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.unit_entries.names !== null &&
				row.unit_entries.lastname1 !== null &&
				row.unit_entries.lastname2 !== null &&
				row.unit.unit_number !== null &&
				row.unit.volume !== null
			){
				if(
					row.unit_entries.names.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit_entries.lastname1.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit_entries.lastname2.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.unit_number.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.volume.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 
					
				){
					res = true;
				}else{
					res = false;
				}
			}
		}

		return res;
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'unit_entries/'+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    }.bind(this));
	}

	onViewDetails(id){
		this.modal_info.handleShow(id);
	}

	onUpdate(id){
		this.props.history.push('/entry_units/edit/'+id);
	}



	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');
		
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Entrada de Unidades
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_distribution"} 
	                submenu={"help_unit_entries"}  />
	                
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input type="date" className="form-control" name="start_date" id="start_date"
								value={this.state.start_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input type="date" className="form-control" name="end_date" id="end_date"
								value={this.state.end_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Folio Desde</span>
							<input type="text" className="form-control" name="start_folio" id="start_folio"
								value={this.state.start_folio} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Folio Hasta</span>
							<input type="text" className="form-control" name="end_folio" id="end_folio"
								value={this.state.end_folio} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-4" style={{marginTop:'10px'}}>
							<button type="button" className="btn btn-info" onClick={this.getList} 
								style={{fontSize:"14px"}}>
								Buscar
							</button>
							<button type="button" className="btn btn-info" onClick={this.newEntry} 
								style={{fontSize:"14px", marginLeft:'10px'}}
								disabled={!this.props.task_unit_entries.create}>
								Nuevo
							</button>
						</div>
							
					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2" style={{marginTop:'20px'}}>
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>
					</div>

					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('DONOT')}>Donador</th>
									<th hidden={this.showColumn('UNIT_NUMBER')}>Número de Unidad</th>
									<th hidden={this.showColumn('COMPONENT')}>Componente</th>
									<th hidden={this.showColumn('ORIGIN')}>Centro de Origen</th>
									<th hidden={this.showColumn('GROUP_RH')}>Grupo & RH</th>
									<th hidden={this.showColumn('GROUP_RH_CONF')}>Grupo & RH Confirmatorio</th>
									<th hidden={this.showColumn('VOLUME')}>Volumen</th>
									<th hidden={this.showColumn('ENTRY_DATE')}>Fecha de Entrada</th>
									<th hidden={this.showColumn('EXPIRED_DATE')}>Fecha de Caducidad</th>
									<th hidden={this.showColumn('CONTROLS')}></th>
								</tr>
							</thead>
							<tbody>
								{this.state.unit_entries.map((unit, i)=>{
									return this.filter(unit) === true ?
										<tr key={i}>
											<td hidden={this.showColumn('DONOT')}>{unit.unit_entries.names+' '+unit.unit_entries.lastname1+' '+unit.unit_entries.lastname2}</td>
											<td hidden={this.showColumn('UNIT_NUMBER')}>{unit.unit.unit_number}</td>
											<td hidden={this.showColumn('COMPONENT')}>{unit.component}</td>
											<td hidden={this.showColumn('ORIGIN')}>{unit.center_name}</td>
											<td hidden={this.showColumn('GROUP_RH')}>{unit.unit.group+(unit.unit.rh === 'POSITIVO'?'+':'-')}</td>
											<td hidden={this.showColumn('GROUP_RH_CONF')}></td>
											<td hidden={this.showColumn('VOLUME')}>{unit.unit.volume} ml</td>
											<td hidden={this.showColumn('ENTRY_DATE')}>{moment(unit.unit_entries.entry_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}</td>
											<td hidden={this.showColumn('EXPIRED_DATE')}>{moment(unit.unit.caducidad).format('DD/MM/YYYY HH:mm')}</td>
											<td hidden={this.showColumn('CONTROLS')}>
											<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} onClick={this.onViewDetails.bind(this, unit.unit_entries.id)}>
													<SvgIcon icon={search} className="icon-align"/>
												</FloatingActionButton>
												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} 
													onClick={this.onUpdate.bind(this, unit.unit_entries.id)}
													disabled={!this.props.task_unit_entries.update}> 
													<SvgIcon icon={pencil2} className="icon-align"/>
												</FloatingActionButton>
												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}}
													iconStyle={{height: 33, width: 33}} 
													onClick={this.onDelete.bind(this, unit.unit_entries.id)}
													disabled={!this.props.task_unit_entries.delete}>
													<SvgIcon icon={bin} className="icon-align"/>
												</FloatingActionButton>
											</td>
										</tr>
									: null
								})}
							</tbody>
						</Table>
					</div>
				</form>

				<ModalInfo {...this.props} onRef={ref => (this.modal_info = ref)}/>
			</div>
		)
	}
}


export default translate('translations') (SampleList);